import isUrlHttp from 'is-url-http'

/** Leaves the app for an absolute http(s) URL. Anything else is refused, and the caller decides what to show. */
export function goToExternalUrl(url: string): boolean {
	if (!isUrlHttp(url)) return false
	window.location.assign(url)
	return true
}
